import React from 'react';

// Local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { widgetsTabFlow as WidgetsTabFlow } from 'modules/widgetsTabFlow';
import { times, map } from 'lodash';

// shown when the backend returns no visible tabs for the member
export const UNAVAILABLE_TABS_MESSAGE = 'Orders and Prescriptions are unavailable for this member.';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailEntitiesWidgetSuccess as MemberDetailEntitiesWidgetSuccess } from 'ui/views/widgets/memberDetailEntitiesWidget';
 *
 * // render
 * <MemberDetailEntitiesWidgetSuccess propName='propValue'/>
 */
export const memberDetailEntitiesWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-detail-entities-widget'>

            {/* <TabSelectionWidgets tabs = { tabsComp } default={ defaultTab }/> */}

            <WidgetsTabFlow
                tabs={ props.tabs }
                theme='plain'
                requestPayload={ props.requestPayload }
                activeTabIndex={ props.activeTabIndex }
                emptyTabsMessage={ UNAVAILABLE_TABS_MESSAGE }
            />
        </div>
    );
};

// set display name
memberDetailEntitiesWidgetSuccess.displayName = 'memberDetailEntitiesWidget';

// set default props
memberDetailEntitiesWidgetSuccess.defaultProps = {
    activeTabIndex: 0,
    requestPayload: {},
};

// prop types
memberDetailEntitiesWidgetSuccess.propTypes = {};


//  *****************************************************

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailEntitiesWidgetPreloader as MemberDetailEntitiesWidgetPreloader } from 'ui/views/widgets/memberDetailEntitiesWidget';
 *
 * // render
 * <MemberDetailEntitiesWidgetPreloader propName='propValue'/>
 */
export const memberDetailEntitiesWidgetPreloader = () => {
    return (
        <div className='ui-member-detail-entities-widget-preloader'>
           <div className='ui-member-detail-entities-widget-preloader__tabList'>
               { map( times( 4 ), item => <div key={ item } className='ui-member-detail-entities-widget-preloader__tabList__tab'></div> ) }
           </div>

           <TableSearchInlineWidgetPreloader
                className='ui-member-detail-entities-widget-preloader__table-preloader'
           />
        </div>
    );
};

// set display name
memberDetailEntitiesWidgetPreloader.displayName = 'memberDetailEntitiesWidgetPreloader';

// set default props
memberDetailEntitiesWidgetPreloader.defaultProps = {};

// prop types
memberDetailEntitiesWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailEntitiesWidget as MemberDetailEntitiesWidget } from 'ui/views/widgets/memberDetailEntitiesWidget';
 *
 * // render
 * <memberDetailEntitiesWidget propName='propValue'/>
 */
export const memberDetailEntitiesWidget = withNetworkState( memberDetailEntitiesWidgetPreloader, memberDetailEntitiesWidgetSuccess );
